import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-ai-stars-generating',
    templateUrl: './ai-stars-generating.component.html',
    styleUrls: ['./ai-stars-generating.component.scss'],
    standalone: false
})
export class AiStarsGeneratingComponent {
  @Input() generating = false;
  @Input() success = false;
  @Input() failed = false;
  @Input() disableHover = false;
}
